import { Add, Delete, Edit } from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import axios from 'axios';
import React, { useState } from 'react';
import clientConfig from '../../../client-config';
import TiptapEditor from '../../../components/forms/TiptapEditor';
import { siteContents } from '../../../constants/siteContents';

const FreeContent = () => {
  const [videos, setVideos] = useState([]);
  const [editingVideo, setEditingVideo] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [editorValue, setEditorValue] = useState('');
  const theme = useTheme();

  const fetchVideos = async () => {
    const res = await axios.get(
      `${clientConfig.backendHOST}/video/siteFreeVideos`,
      {
        headers: {
          'x-auth-token': localStorage.token,
        },
      }
    );
    setVideos(res.data);
  };

  const handleEdit = (video) => {
    setEditingVideo(video);
    setEditorValue(video.videoLeiras);
    setOpenDialog(true);
  };

  const handleDelete = async (videoId) => {
    await axios.delete(
      `${clientConfig.backendHOST}/video/siteFreeVideos/${videoId}`,
      {
        headers: {
          'x-auth-token': localStorage.token,
        },
      }
    );
    fetchVideos();
  };

  const handleSave = async () => {
    const payload = { ...editingVideo, videoLeiras: editorValue };
    const method = payload.videoId ? 'put' : 'post';

    await axios[method](
      `${clientConfig.backendHOST}/video/siteFreeVideos`,
      payload,
      {
        headers: {
          'x-auth-token': localStorage.token,
        },
      }
    );

    setOpenDialog(false);
    setEditingVideo(null);
    fetchVideos();
  };

  const handleAdd = () => {
    setEditingVideo({
      videoCim: '',
      videoType: '',
      videoLeiras: '',
      video_Url: '',
    });
    setEditorValue('');
    setOpenDialog(true);
  };

  const handleChange = (e) => {
    setEditingVideo({ ...editingVideo, [e.target.name]: e.target.value });
  };

  React.useEffect(() => {
    fetchVideos();
  }, []);

  return (
    <Box p={3} mx='auto' maxWidth={'lg'}>
      <Typography variant='h4' gutterBottom>
        Egyéb videós tartalmak szerkesztése
      </Typography>
      <Box textAlign='right' mb={2}>
        <Button variant='contained' startIcon={<Add />} onClick={handleAdd}>
          Új videó
        </Button>
      </Box>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Megjelenés helye</TableCell>
                <TableCell>Cím</TableCell>
                <TableCell>Link</TableCell>
                <TableCell align='right'>Műveletek</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {videos.map((video) => (
                <TableRow key={video.videoId}>
                  <TableCell>{video.videoType}</TableCell>
                  <TableCell>{video.videoCim}</TableCell>
                  <TableCell>{video.video_Url}</TableCell>
                  <TableCell align='right'>
                    <IconButton onClick={() => handleEdit(video)}>
                      <Edit />
                    </IconButton>
                    <IconButton onClick={() => handleDelete(video.videoId)}>
                      <Delete />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth='md'
        fullWidth
      >
        <DialogTitle>Videó tartalom szerkesztése</DialogTitle>
        <DialogContent>
          <TextField
            margin='dense'
            label='Cím'
            fullWidth
            name='videoCim'
            value={editingVideo?.videoCim || ''}
            onChange={handleChange}
            sx={{ marginTop: theme.spacing(2) }}
          />
          <FormControl
            fullWidth
            margin='dense'
            sx={{ marginTop: theme.spacing(2) }}
          >
            <InputLabel>Megjelenés helye</InputLabel>
            <Select
              name='videoType'
              value={editingVideo?.videoType || ''}
              label='Megjelenés helye'
              onChange={handleChange}
            >
              {siteContents.map((item) => (
                <MenuItem key={item.id} value={item.id}>
                  {item.text}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Box mt={2}>
            <TiptapEditor
              content={editorValue}
              onChange={(value) => setEditorValue(value)}
              //height={280}
            />
          </Box>

          <TextField
            margin='dense'
            label='Videó URL'
            fullWidth
            name='video_Url'
            value={editingVideo?.video_Url || ''}
            onChange={handleChange}
            sx={{ marginTop: theme.spacing(2) }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Mégse</Button>
          <Button variant='contained' onClick={handleSave}>
            Mentés
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default FreeContent;
